var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"products",attrs:{"title":"Produkter"}},[_c('button-view',{attrs:{"slot":"tools","label":"Opret"},on:{"click":_vm.createButtonClick},slot:"tools"}),_c('new-table-view',{attrs:{"columns":[
		{
			label: 'Label',
			name: 'alt_label',
			weight: 2
		},
		{
			label: 'Beskrivelse',
			name: 'label',
			weight: 4
		},
		{
			label: 'Varenummer',
			name: 'sku'
		},
		{
			label: 'Alt varenummer',
			name: 'alt_sku'
		},
		{
			label: 'Pris',
			name: 'price',
			filter: 'float',
			align: 'right'
		},
		{
			label: '',
			name: 'delete',
			align: 'right',
			template: {
				name: 'button',
				label: 'Slet'
			}
		}
	],"items":_vm.items},on:{"itemClick":_vm.itemClick,"delete":_vm.itemDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }